import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BankService {
  private readonly http = inject(HttpClient);

  constructor() {}

  readonly rootUrl: string = "https://bank-apis.justinclicks.com/API/V1";

  // SOURCE : https://github.com/kaustubhk24/Indian-Banks-Data/wiki/V1-Documentation#1--api-to-get-bank-details-using-ifsc

  GetState() {
    return this.http.get(`${this.rootUrl}/STATE`);
  }

  GetDistrict(StateName: string) {
    return this.http.get(`${this.rootUrl}/STATE/${StateName}`);
  }

  GetCity(StateName: string, DistrictName: string) {
    return this.http.get(`${this.rootUrl}/STATE/${StateName}/${DistrictName}`);
  }

  GetCenters(StateName: string, DistrictName: string, CityName: string) {
    return this.http.get(`${this.rootUrl}/STATE/${StateName}/${DistrictName}/${CityName}`);
  }

  GetBranches(StateName: string, DistrictName: string, CityName: string, CenterName: string) {
    return this.http.get(`${this.rootUrl}/STATE/${StateName}/${DistrictName}/${CityName}/${CenterName}`);
  }

  GetBranchDetails(StateName: string, DistrictName: string, CityName: string, CenterName: string, BranchNameJson: string) {
    return this.http.get(`${this.rootUrl}/STATE/${StateName}/${DistrictName}/${CityName}/${CenterName}/${BranchNameJson}`);
  }

  GetBankDetailsByIFSC(IFSCCode: string) {
    return this.http.get(`${this.rootUrl}/IFSC/${IFSCCode}`);
  }
}
